import { Product } from '../types/product'

export const mockProducts: Product[] = [
  // Vegetables
  {
    id: 'v1',
    name: 'Fresh Nigerian Yams',
    price: 4.99,
    category: 'Vegetables',
    image:
      'https://images.unsplash.com/photo-1590165482129-1b8b27698780?auto=format&fit=crop&q=80&w=800',
    altText: 'Fresh Nigerian yams on wooden surface',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
  },
  {
    id: 'v2',
    name: 'Ripe Plantains (3 pack)',
    price: 2.49,
    category: 'Vegetables',
    image:
      'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?auto=format&fit=crop&q=80&w=800',
    altText: 'Ripe yellow plantains',
    isWIC: true,
    isEBT: true,
    unit: 'pack',
  },
  {
    id: 'v3',
    name: 'Fresh Cassava Root',
    price: 3.29,
    category: 'Vegetables',
    image:
      'https://images.unsplash.com/photo-1598512752271-33f913a5af13?auto=format&fit=crop&q=80&w=800',
    altText: 'Fresh cassava roots',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
  },
  {
    id: 'v4',
    name: 'Scotch Bonnet Peppers',
    price: 1.99,
    category: 'Vegetables',
    image:
      'https://images.unsplash.com/photo-1583119022894-919a68a3d0e3?auto=format&fit=crop&q=80&w=800',
    altText: 'Colorful scotch bonnet peppers',
    isWIC: true,
    isEBT: true,
    unit: '4 oz',
  },
  {
    id: 'v5',
    name: 'Fresh Okra',
    price: 2.79,
    category: 'Vegetables',
    image:
      'https://images.unsplash.com/photo-1425543103986-22abb7d7e8d2?auto=format&fit=crop&q=80&w=800',
    altText: 'Fresh green okra',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
  },
  {
    id: 'v6',
    name: 'Green Plantains (3 pack)',
    price: 2.29,
    category: 'Vegetables',
    image:
      'https://images.unsplash.com/photo-1603052875302-d376b7c0638a?auto=format&fit=crop&q=80&w=800',
    altText: 'Green unripe plantains',
    isWIC: true,
    isEBT: true,
    unit: 'pack',
  },
  // Grains & Flour
  {
    id: 'g1',
    name: 'Fufu Flour (Pounded Yam)',
    price: 6.99,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?auto=format&fit=crop&q=80&w=800',
    altText: 'Bag of fufu flour',
    isWIC: false,
    isEBT: true,
    unit: '2 lb bag',
  },
  {
    id: 'g2',
    name: 'Garri (Cassava Flakes)',
    price: 5.49,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&q=80&w=800',
    altText: 'Garri cassava flakes in bowl',
    isWIC: false,
    isEBT: true,
    unit: '2 lb bag',
  },
  {
    id: 'g3',
    name: 'Jollof Rice Mix',
    price: 4.99,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1596560548464-f010549b84d7?auto=format&fit=crop&q=80&w=800',
    altText: 'Jollof rice seasoning mix',
    isWIC: false,
    isEBT: true,
    unit: '12 oz',
  },
  {
    id: 'g4',
    name: 'Semolina Flour',
    price: 3.99,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=800',
    altText: 'Semolina flour in bag',
    isWIC: false,
    isEBT: true,
    unit: '2 lb bag',
  },
  {
    id: 'g5',
    name: 'Egusi Seeds (Ground)',
    price: 8.99,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1515543904323-87f0b9e7fa21?auto=format&fit=crop&q=80&w=800',
    altText: 'Ground egusi melon seeds',
    isWIC: false,
    isEBT: true,
    unit: '8 oz',
  },
  // Spices
  {
    id: 's1',
    name: 'Suya Spice Blend',
    price: 3.49,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800',
    altText: 'Suya spice blend in container',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
  },
  {
    id: 's2',
    name: 'Cameroon Pepper',
    price: 4.29,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1599909533681-74a4a1b53f42?auto=format&fit=crop&q=80&w=800',
    altText: 'Ground cameroon pepper',
    isWIC: false,
    isEBT: true,
    unit: '3 oz',
  },
  {
    id: 's3',
    name: 'Crayfish (Ground)',
    price: 5.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1599909533681-74a4a1b53f42?auto=format&fit=crop&q=80&w=800',
    altText: 'Ground dried crayfish',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
  },
  {
    id: 's4',
    name: 'Ogiri (Locust Bean)',
    price: 2.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1532336414038-cf19250c5757?auto=format&fit=crop&q=80&w=800',
    altText: 'Traditional ogiri seasoning',
    isWIC: false,
    isEBT: true,
    unit: '2 oz',
  },
  {
    id: 's5',
    name: 'Curry Powder (Caribbean)',
    price: 3.79,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800',
    altText: 'Caribbean curry powder',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
  },
  // Oils
  {
    id: 'o1',
    name: 'Red Palm Oil',
    price: 7.99,
    category: 'Oils',
    image:
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&q=80&w=800',
    altText: 'Bottle of red palm oil',
    isWIC: false,
    isEBT: true,
    unit: '16 oz',
  },
  {
    id: 'o2',
    name: 'Coconut Oil (Virgin)',
    price: 8.49,
    category: 'Oils',
    image:
      'https://images.unsplash.com/photo-1526947425960-945c6e72858f?auto=format&fit=crop&q=80&w=800',
    altText: 'Virgin coconut oil jar',
    isWIC: false,
    isEBT: true,
    unit: '14 oz',
  },
  {
    id: 'o3',
    name: 'Shea Butter (Cooking Grade)',
    price: 9.99,
    category: 'Oils',
    image:
      'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?auto=format&fit=crop&q=80&w=800',
    altText: 'Cooking grade shea butter',
    isWIC: false,
    isEBT: true,
    unit: '8 oz',
  },
  // Frozen
  {
    id: 'f1',
    name: 'Frozen Goat Meat',
    price: 12.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&q=80&w=800',
    altText: 'Frozen goat meat package',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
  },
  {
    id: 'f2',
    name: 'Frozen Tilapia Fish',
    price: 8.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&q=80&w=800',
    altText: 'Frozen whole tilapia',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
  },
  {
    id: 'f3',
    name: 'Frozen Stockfish',
    price: 14.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?auto=format&fit=crop&q=80&w=800',
    altText: 'Frozen stockfish',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
  },
  {
    id: 'f4',
    name: 'Frozen Bitter Leaf',
    price: 4.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&q=80&w=800',
    altText: 'Frozen bitter leaf package',
    isWIC: true,
    isEBT: true,
    unit: '8 oz',
  },
  // Beverages
  {
    id: 'b1',
    name: 'Malt Drink (6 pack)',
    price: 7.99,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1527960471264-932f39eb5846?auto=format&fit=crop&q=80&w=800',
    altText: 'Pack of malt drinks',
    isWIC: false,
    isEBT: true,
    unit: '6 pack',
  },
  {
    id: 'b2',
    name: 'Hibiscus Tea (Zobo)',
    price: 4.49,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1544787219-7f47ccb76574?auto=format&fit=crop&q=80&w=800',
    altText: 'Dried hibiscus flowers for tea',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
  },
  {
    id: 'b3',
    name: 'Ginger Beer (4 pack)',
    price: 5.99,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?auto=format&fit=crop&q=80&w=800',
    altText: 'Ginger beer bottles',
    isWIC: false,
    isEBT: true,
    unit: '4 pack',
  },
  // Canned Goods
  {
    id: 'c1',
    name: 'Palm Fruit Concentrate',
    price: 5.49,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?auto=format&fit=crop&q=80&w=800',
    altText: 'Can of palm fruit concentrate',
    isWIC: false,
    isEBT: true,
    unit: '28 oz',
  },
  {
    id: 'c2',
    name: 'Corned Beef (Exeter)',
    price: 4.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1599599810769-bcde5a160d32?auto=format&fit=crop&q=80&w=800',
    altText: 'Can of corned beef',
    isWIC: false,
    isEBT: true,
    unit: '12 oz',
  },
  {
    id: 'c3',
    name: 'Sardines in Tomato Sauce',
    price: 2.49,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?auto=format&fit=crop&q=80&w=800',
    altText: 'Can of sardines',
    isWIC: false,
    isEBT: true,
    unit: '5 oz',
  },
  // Snacks
  {
    id: 'sn1',
    name: 'Chin Chin (Fried Dough)',
    price: 3.99,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?auto=format&fit=crop&q=80&w=800',
    altText: 'Bag of chin chin snacks',
    isWIC: false,
    isEBT: true,
    unit: '8 oz',
  },
  {
    id: 'sn2',
    name: 'Plantain Chips',
    price: 2.99,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1566478989037-eec170784d0b?auto=format&fit=crop&q=80&w=800',
    altText: 'Crispy plantain chips',
    isWIC: false,
    isEBT: true,
    unit: '5 oz',
  },
  {
    id: 'sn3',
    name: 'Puff Puff Mix',
    price: 4.49,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=800',
    altText: 'Puff puff batter mix',
    isWIC: false,
    isEBT: true,
    unit: '16 oz',
  },
]

export const categories = [
  'All',
  'Vegetables',
  'Grains & Flour',
  'Spices',
  'Oils',
  'Frozen',
  'Beverages',
  'Canned Goods',
  'Snacks',
]

export const recipeBundles = [
  {
    id: 'bundle1',
    title: 'Jollof Rice Essentials',
    description: 'Everything you need for the perfect party jollof',
    productIds: ['g3', 'o1', 's1', 'v4', 'c2'],
    savings: 3.5,
  },
  {
    id: 'bundle2',
    title: 'Egusi Soup Starter',
    description: 'Traditional Nigerian egusi soup ingredients',
    productIds: ['g5', 'o1', 's3', 'v5', 'f4'],
    savings: 4.25,
  },
  {
    id: 'bundle3',
    title: 'Fufu & Soup Night',
    description: 'Complete fufu dinner with all the fixings',
    productIds: ['g1', 'f1', 'o1', 's2', 'v5'],
    savings: 5.0,
  },
]

export function getProductById(id: string): Product | undefined {
  return mockProducts.find((p) => p.id === id)
}

export function getProductsByCategory(category: string): Product[] {
  if (category === 'All') return mockProducts
  return mockProducts.filter((p) => p.category === category)
}

export function searchProducts(query: string): Product[] {
  const lowerQuery = query.toLowerCase()
  return mockProducts.filter(
    (p) =>
      p.name.toLowerCase().includes(lowerQuery) ||
      p.category.toLowerCase().includes(lowerQuery),
  )
}

export function getWICProducts(): Product[] {
  return mockProducts.filter((p) => p.isWIC)
}

export function getEBTProducts(): Product[] {
  return mockProducts.filter((p) => p.isEBT)
}
